(function($) {
    $(document).ready(function () {
        const hostName = window.location.hostname;
        let directoryUrl = "/wp-content/themes/ixact-wp-theme-3-stockholm/assets/images/";
        if (!(hostName.includes("localhost") || hostName.includes("test") || hostName.includes("dev.artscience.ca"))) {
            directoryUrl = "/wp"+directoryUrl;
        }
        $('.jumbo-carousel').slick({
            autoplay: true,
            arrows: true,
            speed: 600,
            autoplaySpeed: 5000,

            prevArrow: '<button class="slick-prev slick-arrow"><img src="' + directoryUrl + 'arrow-left.svg" /></button>',

            nextArrow: '<button class="slick-next slick-arrow"><img src="' + directoryUrl + 'arrow-right.svg" /></button>'
        });

        $('.home .ihf-slide >.row').slick({
            autoplay: false,
            arrows: true,
            slidesToShow: 3,
            prevArrow: '<button class="slick-prev slick-arrow"><img src="' + directoryUrl + 'arrow-grey.svg"  style="transform: rotate(180deg);" /></button>',
            nextArrow: '<button class="slick-next slick-arrow"><img src="' + directoryUrl + 'arrow-grey.svg" /></button>',
            responsive: [
                {
                    breakpoint: 1200,
                    settings: {
                        slidesToShow: 2
                    }
                },
                {
                    breakpoint: 900,
                    settings: {
                        slidesToShow: 1
                    }
                },
                {
                    breakpoint: 499,
                    settings: "unslick"
                }
            ]
        });
    });

})(jQuery, this);
